<template>
	<c-loader class="c-project-list" v-if="loading" />
	<div class="view-wrapper service-page" v-else>
		<div class="service-page__hero" v-bind:style="{ backgroundImage: 'url(' + service.hero_image.url + ')' }">
			<div class="container">
				<h1 class="service-page__title"><span class="service-page__title-main">{{ service.title }}</span></h1>
				<div class="service-page__abstract" v-html="service.abstract"></div>
			</div>
		</div>

		<div class="container">
			<div class="service-page__flex-content">
				<c-flex-content :content="service.flex_content" />
			</div>
		</div>

		<div class="container">
			<c-services-list />
		</div>
	</div>
</template>

<script>
import * as utils from '@/utils/utils';
import defaultHeadData from '@/utils/defaultHeadData';
import { getServiceBySlug } from '@/api/services.wp.api'
import CServicesList from '@/components/ServicesList';
import CLoader from '@/components/Loader'
import CFlexContent from '@/components/FlexContent'

export default {
	name: 'service',
	components: {
		CServicesList,
		CLoader,
		CFlexContent
	},
	data: () => ({
		slug: null,
		serviceData: {},
		headData: defaultHeadData,
		loading: true
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		service() {
			return this.serviceData
		}
	},
	watch: {
		'$route': function() {
			this.slug = this.$store.state.route.params.slug
			this.fetchServiceData()
			utils.setHtmlLang(this.settings.currentLang)
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: true })
		}
	},
	beforeMount() {
		this.slug = this.$store.state.route.params.slug
		this.fetchServiceData()
	},
	methods: {
		fetchServiceData() {
			getServiceBySlug({ lang: this.settings.currentLang, slug: this.slug }).then(service => {
				if (service) {
					utils.setHtmlLang(this.settings.currentLang)
					this.serviceData = service
					this.$store.dispatch('setAltLanguageLink', { lang: service.lang, link: (service.lang == 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug)})
					if(this.serviceData.alternateLanguage) {
						this.$store.dispatch('setAltLanguageLink', { lang: service.alternateLanguage.lang, link: (service.alternateLanguage.lang == 'en-us' ? '/en/service/' + service.alternateLanguage.slug : '/service/' + service.alternateLanguage.slug)})
					}
					this.updateHeadData()
					this.loading = false
				} else {
					this.$router.push(this.settings.currentLang == 'en-us' ? '/en/404' : '/404')
				}
			}).catch(err => this.$router.push(this.settings.currentLang == 'en-us' ? '/en/404' : '/404'))
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.service) {
				this.headData = utils.transformHeadData({
					meta: this.service.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>


<style lang="scss">

	@import "../assets/css/helpers";

	.service-page {
		margin-top: -3rem;

		p {
			max-width: 45rem;
			margin: 1.5rem 0;
			line-height: 1.6;
		}
		img {
			max-width: 45rem;
		}
		.c-services-list {
			margin: 4rem 0;

			@include mq($from: medium) {
				margin: 8rem 0;
			}
		}
		&__hero {
			padding: 7rem 0 4rem 0;
			margin-bottom: 3rem;
			background-color: $colorGrayLight;
			background-size: cover;
			background-position: bottom center;

			@include mq($from: medium) {
				padding: 12rem 0 2rem 0;
			}
		}
		&__title {
			color: $colorBrandSecondary;
		}
		&__title-main {
			display: inline-block;
			width: auto;
			border-bottom: 4px solid $colorHighlight;
			font-size: 1.75rem;

			@include mq($from: medium) {
				font-size: 3rem;
			}
		}
		&__title-addon {
			display: block;
			font-size: 1rem;

			@include mq($from: medium) {
				font-size: 1.4rem;
			}
		}
		&__title-addon, &__title-main {
			color: $colorBrandSecondary;
		}
		&__abstract {
			padding-left: 1rem;
		}
		&__abstract p {
			font-family: $fontFamilyBase;
			font-size: 1.5rem;
			line-height: 1.4;
			max-width: 35rem;
		}
	}

</style>



// WEBPACK FOOTER //
// Service.vue?54afe40f